import { mainApi } from "../../../../api";

export const orderRequestQuery = (childrenId: string, isEnabled?: boolean) => ({
    queryKey: ["order_request", childrenId],
    queryFn: async () => mainApi.get(`order_request/${childrenId}`),
    cacheTime: 1000,
    staleTime: 1000,
    enabled: isEnabled,
});
